export const environment = {
  production: true,
  ADMIN_BASE_URL:
    // 'http://localhost:3000/offline/api', 
    'https://d1aczabmblwch8.cloudfront.net/dev/api',
  FILE_BASE_URL:
    'https://mango-public-storage-dev.s3.eu-central-1.amazonaws.com',
};
